import { render } from "./AlarmStatusBadge.vue?vue&type=template&id=c8623442"
import script from "./AlarmStatusBadge.vue?vue&type=script&lang=js"
export * from "./AlarmStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__